module.exports = __webpack_public_path__ + "56b50ac6b8e278c122188c144f277365.svg";